var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWordpress(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "#21759B",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 0C5.4 0 0 5.4 0 12s5.4 12 12 12 12-5.4 12-12S18.6 0 12 0zM1.2 12c0-1.6.3-3.1.9-4.5L7.4 22C3.7 20.2 1.2 16.4 1.2 12zM12 22.8c-1.1 0-2.1-.2-3.1-.4l3.3-9.5 3.4 9.3c0 .1.1.1.1.2-1.2.4-2.4.4-3.7.4zm1.5-14.1c.6 0 1.2-.1 1.2-.1.6-.1.5-.9-.1-.9 0 0-1.8.1-2.9.1-1.1 0-2.9-.1-2.9-.1-.6 0-.7.9-.1.9 0 0 .5.1 1.1.1l1.7 4.7-2.4 7.2-4-11.9c.6 0 1.2-.1 1.2-.1.6-.1.5-.9-.1-.9 0 0-1.8.1-2.9.1-.2 0-.5 0-.8 0C3.6 4.6 7.5 1.2 12 1.2c3.4 0 6.4 1.3 8.7 3.4-.1 0-.1 0-.2 0-1.1 0-1.9.9-1.9 2 0 .9.5 1.7 1.1 2.6.4.7.9 1.6.9 2.9 0 .9-.3 2-.8 3.4l-1.1 3.6-3.9-11.7c.6 0 1.2-.1 1.2-.1.6-.1.5-.9-.1-.9 0 0-1.8.1-2.9.1zm3.2 14c0 .1 0 .1 0 0l3.3-9.5c.6-1.5.8-2.7.8-3.8 0-.4 0-.8-.1-1.1.8 1.5 1.3 3.2 1.3 5 0 3.9-2.1 7.3-5.3 9.4z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWordpress);
export default __webpack_public_path__ + "static/media/wordpress.68cf6dda2f538acb970af99f6b5a4df5.svg";
export { ForwardRef as ReactComponent };